import { render, staticRenderFns } from "./EditBriefView.vue?vue&type=template&id=3b666123&scoped=true"
import script from "./EditBriefView.vue?vue&type=script&lang=js"
export * from "./EditBriefView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b666123",
  null
  
)

export default component.exports